import {
  FileDetailsDTO,
  SignatureDTO,
  DocumentClassDTO,
  I18nData,
  SignatureValidationCode
} from '../../api/plyca-dtos';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  NgZone,
  OnDestroy
} from '@angular/core';
import { DocumentService } from '../document.service';
import { ServiceLocator } from './../../ServiceLocator';
import { Location } from '@angular/common';
import { UIService } from '../../ui.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { SignatureUtils } from '../../../services/signature.utils';


@Component({
  selector: 'documentFile',
  templateUrl: 'documentFile.template.html'
})
export class documentFileComponent extends BaseComponent implements OnInit, OnDestroy {
  [x: string]: any;
  @Input() edit: boolean;
  @Input() fileDetails: any;
  @Input() documentClass: DocumentClassDTO;
  @Output() deleteFileItem = new EventEmitter();
  @Output() addSignature = new EventEmitter();
  @Output() modifyFileItem = new EventEmitter();
  @Input() readonly = false;

  documentId = 'Sin Información';
  documentService: DocumentService;
  location: Location;
  private uiService: UIService;
  public editActive = true;

  constructor(
    private zone: NgZone,
    public appConfig: AppConfiguration,
    private signatureUtils: SignatureUtils
  ) {
    super();
    this.documentService = ServiceLocator.injector.get(DocumentService);
    this.uiService = ServiceLocator.injector.get(UIService);
    this.location = ServiceLocator.injector.get(Location);
  }


  ngOnInit(): void {

    // Se estable la visualización del botón editar por propiedad de configuración de cliente.
    this.editActive = this.appConfig.getValue('forms.uploadfiles.editButton.visible');

  }

  ngOnDestroy(): void {
    this.zone = null;
    super.ngOnDestroy();
  }

  signatures(fileDetails: FileDetailsDTO): Array<SignatureDTO> {
    // return signatures;
    return SignatureDTO.getSignatures(fileDetails);
  }

  viewFile(fileItem: FileDetailsDTO) {
    console.log('viewFile FileDetailsDTO:', fileItem);
    this.documentService.viewFile(fileItem);
  }

  downloadFile(fileItem: FileDetailsDTO) {
    // console.log("Método downloadFile");

    this.documentService.downloadFile(fileItem);
  }

  downloadEmbedded(fileItem: FileDetailsDTO) {
    this.documentService.downloadEmbedded(fileItem);
  }

  deleteFile(fileItem: FileDetailsDTO) {
    console.log('Método downloadFile');
    this.deleteFileItem.emit(fileItem);
  }

  modifyFile(fileItem: FileDetailsDTO) {
    console.log('Método uodateFile');
    this.modifyFileItem.emit(fileItem);
  }

  backClicked() {
    console.log('documentFile.backClicked');
    this.uiService.routeBack();
  }

  validateSignDocument(
    signature: SignatureDTO,
    fileItem: FileDetailsDTO
  ) {
    console.log('Método validateSignDocument');
    this.documentService.validateSignDocument(signature, fileItem);
  }

  isValidSignature(signature: SignatureDTO): number {
	    return SignatureDTO.isValid(signature);
  }

}
